import { AuthProvider } from 'react-admin';
import authApi from './services/authApi';
import { getCurrentUserPermission } from './hooks/useFetchPermissions';

const authProvider: AuthProvider = {
    login: async ({ phone, password, session_id }) => {
        try {
            const { token, userData } = await authApi.login({ phone, password, session_id });

            authApi.setToken(token);
            authApi.setUser(userData);

            await getCurrentUserPermission(token);

            return Promise.resolve();
        } catch (error) {
            console.error('Login error:', error);
            return Promise.reject(error);
        }
    },

    logout: () => {
        authApi.logout();
        return Promise.resolve();
    },

    checkError: () => Promise.resolve(),

    checkAuth: () => (authApi.isAuthenticated() ? Promise.resolve() : Promise.reject()),

    getPermissions: async () => {
        try {
            const token = authApi.getToken();
            if (!token) {
                return { base: [] };
            }
            const permissions = await authApi.getUserPermissions(token);
            localStorage.setItem('permissions', JSON.stringify(permissions));
            return {
                base: permissions || [],
            };
        } catch (error) {
            console.error('Error fetching permissions:', error);
            return { base: [] };
        }
    },

    getIdentity: async (): Promise<any> => {
        return authApi.getUser();
    },
};

export default authProvider;
